import { ref} from "vue";

export function useProjectEnums() {

    const taskDelayEnums = ref({
        MINUTE: {
            value: 'minutes',
            formula: 60 * 1000
        },
        HOUR: {
            value: 'hours',
            formula: 60 * 60 * 1000
        },
        DAY: {
            value: 'day',
            formula: 24 * 60 * 60 * 1000
        },
        WEEK: {
            value: 'week',
            formula: 7 * 24 * 60 * 60 * 1000
        },
        MONTH: {
            value: 'month',
            formula: 30 * 24 * 60 * 60 * 1000
        },
        YEAR: {
            value: 'year',
            formula: 365 * 24 * 60 * 60 * 1000
        }
    })

    const projectStatusEnums = ref({
        All: 'All',
        NOT_STARTED: 'NOT_STARTED',
        IN_PROGRESS: 'IN_PROGRESS',
        PENDING: 'PENDING',
        FINISHED: 'FINISHED',
        CANCELLED: 'CANCELLED',
        ARCHIVED: 'ARCHIVED',
        SUSPENDED: 'SUSPENDED',
    })

    const taskQuickActions = ref({
        EDIT: {
            name: 'button.edit',
            icon: 'fas fa-edit',
            value: 'EDIT'
        },
        ADD_SUB_TASK: {
            name: 'tasks.addChecklist',
            icon: 'fa fa-plus',
            value: 'ADD_SUB_TASK'
        },
        ADD_COMMENT: {
            name: 'projects.publish_text',
            icon: 'fa fa-plus',
            value: 'ADD_COMMENT'
        },
        ADD_FILE: {
            name: 'tasks.addAttachFile',
            icon: 'fa fa-file',
            value: 'ADD_FILE'
        },
        DELETE: {
            name: 'button.delete',
            icon: 'fa fa-trash',
            value: 'DELETE'
        },
    })


    return { taskDelayEnums, projectStatusEnums, taskQuickActions }
}
